import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
/**
 * A reader's report about an article. Only editors ever load these: the API
 * returns an empty set to anybody else.
 */
export default class WikiReport extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "reason", Model.attribute('reason'));
    _defineProperty(this, "detail", Model.attribute('detail'));
    _defineProperty(this, "isResolved", Model.attribute('isResolved'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "resolvedAt", Model.attribute('resolvedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "resolvedBy", Model.hasOne('resolvedBy'));
    _defineProperty(this, "article", Model.hasOne('article'));
  }
}
flarum.reg.add('linkrobins-wiki', 'common/models/WikiReport', WikiReport);